import React, { useEffect, useState } from 'react';

const GoogleChat: React.FC = () => {
	const [environment, setEnvironment] = useState('sit');
	const [menuKey, setMenuKey] = useState('BrightspeedChat');
	const [email, setEmail] = useState('');
	const [jwthost, setJwthost] = useState('');
	const [ccaiphost, setCcaiphost] = useState('');
	const [companyID, setCompanyID] = useState('');
	const [theMenuKey, setTheMenuKey] = useState('BrightspeedChat');
	const [ujet, setUjet] = useState<any>(null);
	const [chatStarted, setChatStarted] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		// Load the script when the component mounts
		const script = document.createElement('script');
		script.src = 'https://websdk.ujet.co/v2/loader.js';
		script.async = true;
		document.head.appendChild(script);

		return () => {
			document.head.removeChild(script);
		};
	}, []);

	useEffect(() => {
		setUjetParams();
	}, [environment]);

	const setUjetParams = () => {
		switch (environment) {
			case 'dev':
				setJwthost('https://apgx-dev.brightspeed.com/cc-jws-generator');
				setCcaiphost('https://brspd-dev-ccaip-70dj2d3.ue1.ccaiplatform.com/');
				setCompanyID('166913585003974588122c3bd9631be86');
				setTheMenuKey('BrightspeedChat');
				break;
			case 'sit':
				setJwthost('https://apgx-uat.brightspeed.com/cc-jws-generator');
				setCcaiphost('https://brspd-sit-ccaip-fdnnfsw.ue1.ccaiplatform.com');
				setCompanyID('1669137598978574827316fc646fe5ed2');
				setTheMenuKey('BrightspeedChat');
				break;
			case 'prd':
				setJwthost('https://apgx.brightspeed.com/cc-jws-generator');
				setCcaiphost('https://brspd-prd-ccaip-h2e71d6.ue1.ccaiplatform.com/');
				setCompanyID('16691379530624442e9730a35fcd8dfcf');
				setTheMenuKey('BrightspeedChat');
				break;
			default:
				break;
		}
	};

	const getAuthToken = async () => {
		console.log('!!!! Running getAuthToken');
		try {
			const body = email ? { email } : {};
			const response = await fetch(jwthost, {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(body),
			});
			const tkn = await response.json();
			return tkn;
		} catch (err) {
			console.error('JWT Error: ' + err);
		}
	};

	const startGoogleChat = () => {
		console.log('!!!! Starting chat from button ');
		if (chatStarted) return;
		setChatStarted(true);
		setIsLoading(false);

		// Disable the button
		const button = document.getElementById('theButton') as HTMLButtonElement;
		if (button) button.disabled = true;

		// Call ujet
		console.log('!!!! creating ujet object ');
		if (ujet != null) ujet.destroy();
		const newUjet = new (window as any).UJET({
			companyId: companyID,
			authenticate: getAuthToken,
			launcher: false,
			host: ccaiphost,
			logo: 'https://static.brightspeed.com/assets/images/chat/chat-ball-button-1x.png',
			style: {
				'--primary-color': '#F1684A',
				'--link-color': '#F1684A',
			},
			translation: {
				en: {
					ujet_message_chat_start: '',
					ujet_greeting: '',
					ujet_message_queue: '',
					ujet_channel_chat: '',
					ujet_common_support: '',
					ujet_chat_end: 'End Chat',
					ujet_rating_feedback_placeholder: 'Let us know how we can improve.',
					ujet_rating_result_subtitle: 'Here at Brightspeed we appreciate your feedback',
					ujet_rating_result_title: 'Thank you!',
					ujet_rating_title: 'Rate Your Brightspeed Experience',
				},
			},
			customData: {
				email: {
					label: 'email',
					value: email,
				},
				pageid: {
					label: 'pageid',
					value: 'test',
				},
				webenv: {
					label: 'webenv',
					value: 'GTM',
				},
				useragent: {
					label: 'useragent',
					value: navigator.userAgent,
				},
				browser: {
					label: 'browser',
					value: navigator.appVersion,
				},
				platform: {
					label: 'platform',
					value: navigator.platform,
				},
				url: {
					label: 'url',
					value: document.URL,
				},
			},
		});
		setUjet(newUjet);
		console.log('!!!! ujet object in startGoogleChat=');
		console.log('Starting');
		newUjet.start({ menuKey: theMenuKey });

		const chatClosedCallback = () => {
			setChatStarted(false);
			const button = document.getElementById('theButton') as HTMLButtonElement;
			if (button) button.disabled = false;
		};

		newUjet.on('close', chatClosedCallback);
	};

	const handleEnvironmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		setEnvironment(e.target.value);
	};

	const handleMenuKeyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setMenuKey(e.target.value);
		setTheMenuKey(e.target.value);
	};

	const handleStartChat = () => {
		setIsLoading(true);
		startGoogleChat();
	};

	return (
		<>
			<div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
				<h1 className="text-lg font-semibold mb-4 leading-6 text-gray-900">Google chatbot</h1>
				{/* chatbot code */}
				<div className="max-w-sm bg-white overflow-hidden mt-2">
					<div className="mb-4">
						<label htmlFor="environment" className="flex text-gray-700 text-sm font-semibold mb-1">
							Environment:
						</label>
						<select
							className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
							name="environment"
							id="environment"
							value={environment}
							onChange={handleEnvironmentChange}
						>
							<option value="dev">dev</option>
							<option value="sit">sit</option>
							<option value="prd">prd</option>
						</select>
					</div>
					<div className="mb-4">
						<label htmlFor="menuKey" className="flex text-gray-700 text-sm font-semibold mb-1">
							Menu Key:
						</label>
						<input
							className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
							type="text"
							id="menuKey"
							name="menuKey"
							value={menuKey}
							onChange={handleMenuKeyChange}
						/>
					</div>
					<button
						className="inline-flex mt-2 justify-center rounded-md bg-[#f8c246] px-4 py-2 text-sm font-semibold text-black shadow-sm hover:bg-[#f8c246] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
						type="button"
						id="theButton"
						onClick={handleStartChat}
					>
						{isLoading ? 'Loading...' : 'Start Chat'}
					</button>
				</div>
			</div>
		</>
	);
};

export default GoogleChat;
